import React from 'react';
import { Phone } from 'lucide-react';

const StickyCallButton = () => {
  return (
    <a
      href="tel:+919351292512"
      className="fixed bottom-24 right-4 md:right-6 z-50 bg-alden-navy hover:bg-alden-navy-light text-white rounded-full p-3 md:p-4 shadow-2xl transition-all duration-300 hover:scale-110 group"
      aria-label="Call Now"
    >
      <Phone className="w-5 h-5 md:w-6 md:h-6" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 md:px-4 py-2 rounded-lg text-xs md:text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none hidden md:block">
        Call: +91 9351292512
      </span>
      {/* Pulse animation */}
      <span className="absolute inset-0 rounded-full bg-alden-navy animate-ping opacity-75"></span>
    </a>
  );
};

export default StickyCallButton;
